import React, { ReactNode } from 'react'

import { Button, Link, LinkVariant } from '@gousto-internal/citrus-react'

import {
  FoodBoxPageSections,
  HowGoustoFoodBoxesWorkSections,
  MealPlanningSections,
  TargetUri,
  trackCTAClick,
  TrackingActions,
} from '../types/tracking'

type LandingPageButtonProps = {
  startOnboarding: (targetUri: TargetUri) => void
  sectionName: HowGoustoFoodBoxesWorkSections | MealPlanningSections | FoodBoxPageSections
  target: TargetUri
  children: ReactNode
  asLink?: boolean
  action: TrackingActions
  whiteText?: boolean
}

export const LandingPageButton = ({
  sectionName,
  target,
  children,
  asLink = false,
  action,
  startOnboarding,
  whiteText,
}: LandingPageButtonProps) => {
  const handleClick = () => {
    startOnboarding(target)
    trackCTAClick(action, sectionName, target)
  }

  if (asLink) {
    return (
      <Link
        variant={whiteText ? LinkVariant.None : undefined}
        style={whiteText ? { color: 'white', textDecorationLine: 'underline' } : {}}
        onClick={handleClick}
      >
        {children}
      </Link>
    )
  }

  return (
    <Button width={['100%', 'auto']} onClick={handleClick}>
      {children}
    </Button>
  )
}
